<div class="mechanics-content">
  <div class="text-lg font-bold">Rush In Between!</div>

  <ul class="info list-disc">
    <li>Choose Call, Pair or Trio before deal time ends!</li>
    <li>
      You win 2 times your bet for Call if the Third Card is In Between the First and Second Base
      Cards.
    </li>
    <li>You win 3 times your bet for Pair if the three cards form a two similar numbers.</li>
    <li>You win 50 times your bet for Trio if the three cards are the same numbers.</li>
    <li>
      Bonus Coins are received equal to your (Minimum Bet * Bonus Rate) if you make certain numbers
      of consecutive wins, no matter the Deal Number. Losing a Deal or reaching the highest bonus
      restarts the count.
    </li>
  </ul>

  <div class="!mt-8 text-lg font-bold">Classic In Between!</div>

  <ul class="info list-disc">
    <li>Buy In and take a Seat!</li>
    <li>Wait for your turn.</li>
    <ul class="info list-disc">
      <li>(While waiting, you may want to play Rush!)</li>
    </ul>
    <li>Receive the First and Second Base Cards and choose:</li>
    <ul class="info list-disc">
      <li>Call if you think the Third Card is In Between the First and Second Cards.</li>
      <li>Higher if you think the Third Card is higher of the pair of Base Cards.</li>
      <li>Lower if you think the Third Card is lower of the pair of Base Cards.</li>
      <li>Fold if you don’t want to play.</li>
    </ul>
    <li>Note, different Tables have different rules.</li>
  </ul>
</div>
